import { createSignal, onMount, batch } from 'solid-js'
import { Portal } from 'solid-js/web'
import { res2json } from '@/utils'
import * as constants from '@lib/constants'
import { addToast } from '@/components/Toast'
import account from '@/store/account'

export default function Robot() {
  const [minBetStart, setMinBetStart] = createSignal(constants.defaultNob3RobotMinBetStart)
  const [maxBetStart, setMaxBetStart] = createSignal(constants.defaultNob3RobotMaxBetStart)
  const [minDeposit, setMinDeposit] = createSignal(constants.defaultRobotMinDeposit)
  const [maxDeposit, setMaxDeposit] = createSignal(constants.defaultRobotMaxDeposit)
  const [minWithdrawal, setMinWithdrawal] = createSignal(constants.defaultRobotMinWithdrawal)
  const [maxWithdrawal, setMaxWithdrawal] = createSignal(constants.defaultRobotMaxWithdrawal)
  const [maxScore, setMaxScore] = createSignal(constants.defaultRobotMaxScore)

  const [loading, setLoading] = createSignal(true)
  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  async function load() {
    setLoading(true)
    return fetch(`/api/${account().game_code}/settings/robot`).then(res2json).then(r => {
      batch(() => {
        setMinBetStart(r.data?.min_bet_start ?? constants.defaultNob3RobotMinBetStart)
        setMaxBetStart(r.data?.max_bet_start ?? constants.defaultNob3RobotMaxBetStart)
        setMinDeposit(r.data?.min_deposit ?? constants.defaultRobotMinDeposit)
        setMaxDeposit(r.data?.max_deposit ?? constants.defaultRobotMaxDeposit)
        setMinWithdrawal(r.data?.min_withdrawal ?? constants.defaultRobotMinWithdrawal)
        setMaxWithdrawal(r.data?.max_withdrawal ?? constants.defaultRobotMaxWithdrawal)
        setMaxScore(r.data?.max_score ?? constants.defaultRobotMaxScore)
      })
    }).finally(() => { setLoading(false) })
  }
  onMount(() => {
    load()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/robot`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        min_bet_start: minBetStart(),
        max_bet_start: maxBetStart(),
        min_deposit: minDeposit(),
        max_deposit: maxDeposit(),
        min_withdrawal: minWithdrawal(),
        max_withdrawal: maxWithdrawal(),
        max_score: maxScore(),
      })
    }).then(res2json).then(() => {
      addToast({ message: '已保存' })
    }).finally(() => { setSending(false) })
  }

  async function reset() {
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/robot`, {
      method: 'DELETE'
    }).then(res2json).then(() => load()).then(() => {
      addToast({ message: '已重置' })
    }).finally(() => { setSending(false) })
  }

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>机器人配置</li>
          </ul>
        </div>
        <h2 class="text-xl">机器人配置</h2>
        <form onSubmit={submit} class="flex flex-col gap-4">
          <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6">
            <div class="form-control">
              <div class="label"><span class="label-text">最小开始投注时间</span></div>
              <label class="input input-bordered flex items-center gap-2">
                <input type="number" name="min_bet_start" value={minBetStart()} onChange={e => setMinBetStart(parseInt(e.target.value))} min={constants.minNob3RobotMinBetStart} max={constants.maxNob3RobotMinBetStart} class="grow" />
                <span>秒</span>
              </label>
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最大开始投注时间</span></div>
              <label class="input input-bordered flex items-center gap-2">
                <input type="number" name="max_bet_start" value={maxBetStart()} onChange={e => setMaxBetStart(parseInt(e.target.value))} min={constants.minNob3RobotMaxBetStart} max={constants.maxNob3RobotMaxBetStart} class="grow" />
                <span>秒</span>
              </label>
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最小上分</span></div>
              <input type="number" name="min_deposit" value={minDeposit()} onChange={e => setMinDeposit(parseInt(e.target.value))} min={constants.minRobotMinDeposit} max={constants.maxRobotMinDeposit} class="input input-bordered grow" />
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最大上分</span></div>
              <input type="number" name="max_deposit" value={maxDeposit()} onChange={e => setMaxDeposit(parseInt(e.target.value))} min={constants.minRobotMaxDeposit} max={constants.maxRobotMaxDeposit} class="input input-bordered grow" />
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最小下分</span></div>
              <input type="number" name="min_withdrawal" value={minWithdrawal()} onChange={e => setMinWithdrawal(parseInt(e.target.value))} min={constants.minRobotMinWithdrawal} max={constants.maxRobotMinWithdrawal} class="input input-bordered grow" />
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最大下分</span></div>
              <input type="number" name="max_withdrawal" value={maxWithdrawal()} onChange={e => setMaxWithdrawal(parseInt(e.target.value))} min={constants.minRobotMaxWithdrawal} max={constants.maxRobotMaxWithdrawal} class="input input-bordered grow" />
            </div>
            <div class="form-control">
              <div class="label"><span class="label-text">最大分</span></div>
              <input type="number" name="max_score" value={maxScore()} onChange={e => setMaxScore(parseInt(e.target.value))} min={constants.minRobotMaxScore} max={constants.maxRobotMaxScore} class="input input-bordered grow" />
            </div>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-5 gap-4 pt-4">
            <div class="hidden md:block md:col-span-3"></div>
            <button type="button" onClick={() => reset()} class="btn w-full" disabled={sending()}>重置预设值</button>
            <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>保存</button>
          </div>
        </form>
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}
